<template>
    <v-card flat>

        <v-overlay :value="loadingShipmentData">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-toolbar dense color="bal-gray">
            <v-toolbar-title>{{
                    `${ activeShipment.title } / ${ activeShipment.vehicle_reg_number }`
                }}
            </v-toolbar-title>

            <v-spacer></v-spacer>
            <v-btn
                    v-if="hasPermissionForAction(PermissionsConstants.SHIPMENT, PermissionsConstants.EDIT)"
                    dark
                    color="bal-red"
                    @click="onToggleStatus"
            >
                <v-icon>{{ activeShipment.status === "waiting" ? "check" : "undo" }}</v-icon>
                {{ activeShipment.status === "waiting" ? "Done" : "Waiting" | t }}
            </v-btn>
            <v-btn
                    v-if="hasPermissionForAction(PermissionsConstants.SHIPMENT, PermissionsConstants.EDIT)"
                    dark
                    color="bal-red"
                    @click="editShipment"
                    class="ml-2"
            >
                <v-icon>edit</v-icon>
                {{ "Edit" | t }}
            </v-btn>
            <v-menu
                    offset-y
                    bottom
                    left
                    v-if="hasPermissionForAction(PermissionsConstants.SHIPMENT, PermissionsConstants.DELETE)"
            >
                <template v-slot:activator="{ on }">
                    <v-btn color="bal-dark-gray" class="px-2 ml-2 mx-2" style="min-width: 0;" dark v-on="on">
                        <v-icon>expand_more</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item @click="handleDeleteClick">
                        <v-list-item-title style="color: red">{{ t("Delete") }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
            <v-btn @click="closeDrawer()" icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-tabs v-model="tab" background-color="bal-gray" color="bal-red">
            <v-tab
                    v-for="item in tabs"
                    :key="item"
                    style="text-transform: none !important;"
            >
                {{ item | t }}
            </v-tab>
            <v-tab-item>
                <info-tab/>
            </v-tab-item>
            <v-tab-item>
                <logs-tab/>
            </v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";

import { PermissionsConstants } from "@/permissions";
import InfoTab from "./tab-items/general-tab.vue";
import LogsTab from "./tab-items/logs-tab.vue";

export default {
    name: "shipment-view",
    components: { LogsTab, InfoTab },
    data() {
        return {
            tab: 0,
            tabs: ["General"]
        };
    },
    async mounted() {
        document.addEventListener("keydown", this.nextTab);
        await this.getShipmentData(this.$route.params.shipmentId);
        if (this.user && this.user.role === "superadmin") {
            this.tabs.push("Logs")
        }
    },
    computed: {
        ...mapState("ShipmentStore", ["activeShipment", "loadingShipmentData"]),
        ...mapState(["user"]),
        ...mapGetters(["hasPermissionForAction"]),
        PermissionsConstants() {
            return PermissionsConstants;
        }
    },
    destroyed() {
        document.removeEventListener("keydown", this.nextTab);
    },
    methods: {
        ...mapActions("ShipmentStore", ["getShipmentData", "toggleStatus", "deleteShipment"]),
        closeDrawer() {
            this.$router.push({ name: "shipment-list" });
        },
        editShipment() {
            this.$router.push({
                name: "shipment-edit",
                params: { shipmentId: this.$route.params.shipmentId }
            });
        },
        onToggleStatus() {
            this.toggleStatus({ shipmentId: this.$route.params.shipmentId, fetchItemData: true })
        },
        nextTab(e) {
            if (e.keyCode === 69 && (e.metaKey || e.ctrlKey)) {
                e.preventDefault();
                this.editShipment();
            }
            if (e.key === "ArrowLeft") {
                if (this.tab > 0) {
                    this.tab -= 1;
                }
            } else if (e.key === "ArrowRight") {
                if (this.tab + 1 < this.tabs.length) {
                    this.tab += 1;
                }
            }
        },
        async handleDeleteClick() {
            if (confirm(this.t("Are you sure you want to delete this shipment?"))) {
                await this.deleteShipment({
                    shipmentId: this.activeShipment.id
                });
            }
        }
    }
};
</script>

<style scoped></style>
